module.exports = __webpack_public_path__ + "img/chz-level-2.c228d3fd.webp";